import SignUpContainer from "../../../Components/Authentication/SignUp";

const SignUp = () => {
  return <SignUpContainer />;
};

export default SignUp;
